export enum Type {
  DEFAULT = 'default',
  HORIZONTAL = 'horizontal',
  HORIZONTAL_RIGHT = 'horizontal-right',
}
